
require.register("graphlib/lib/index.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "graphlib");
  (function() {
    // Includes only the "core" of graphlib
module.exports = {
  Graph: require("./graph"),
  version: require("./version")
};
  })();
});